export default function documentName(document) {
    const nameField = document?.document_type?.fields?.find(i => i.name === "name");
    if (!nameField) return null;
    return document.values[nameField.id] || null;
}
